// removed by extract-text-webpack-plugin
module.exports = {"paginationContainer":"paginationContainer--1Y82M"};